import { initializeApp } from "firebase/app";

import {
    getAuth
} from "firebase/auth";


const firebaseConfig = {
    apiKey: "AIzaSyCKspK98fCuifrVPQqYSwnZR9OLhgPUEFA",
    authDomain: "edumed-e6ac3.firebaseapp.com",
    projectId: "edumed-e6ac3",
    storageBucket: "edumed-e6ac3.firebasestorage.app",
    messagingSenderId: "161373552998",
    appId: "1:161373552998:web:01a6ce82235e233f4408a7"
};


const app = initializeApp(firebaseConfig);
const auth = getAuth(app);



// Export the initialized Firebase app and auth instance
// so they can be used in other parts of the application
export { app, auth };
